// Packages
import { useTheme } from "@mui/material/styles";

// MUI
import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";

// Component
import { StyledLabel } from '../StyledLabel';

// Icon
import { ReactComponent as CheckedIcon } from "assets/images/icons/icn_checked.svg";
import { ReactComponent as UnCheckedIconIcon } from "assets/images/icons/icn_unchecked.svg";

export const StyledRadioButtonGroup = ({
  showEditGeneral,
  label,
  value,
  isIndent,
  tooltip,
  isPro = false,
  onChange
}) => {
  const theme = useTheme();

  return (
    <StyledLabel
      {...{
        isIndent,
        label,
        tooltip,
        isPro,
        isProEnabled: Boolean(value),
      }}
    >
      <RadioGroup
        row
        value={value ? "enable" : "disable"}
        onChange={(e) => onChange(e.target.value === "enable")}
      >
        {["Enable", "Disable"].map((option) => (
          <FormControlLabel
            key={option}
            value={option.toLowerCase()}
            control={
              <Radio
                icon={<UnCheckedIconIcon />}
                checkedIcon={<CheckedIcon />}
              />
            }
            label={option}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: theme.typography.customFontSize[2],
                color: theme.palette.primary.greyPrimary,
              },
            }}
            disabled={!showEditGeneral}
          />
        ))}
      </RadioGroup>
    </StyledLabel>
  );
};